// extracted by mini-css-extract-plugin
module.exports = {"loadingModalWrapper":"c"};